import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faTrash, faGripDotsVertical } from "@fortawesome/pro-solid-svg-icons";

const USER_DATA: any[] = [];

const COLUMNS_SCHEMA = [
  {
    key: "position",
    type: "position",
    label: " ",
    required: false,
  },
  {
    key: "title",
    type: "title",
    label: "Link / Section Title",
    required: true,
  },
  {
    key: "linkType",
    type: "select",
    label: "Link To",
    required: true,
  },
  {
    key: "link",
    type: "link",
    label: "destination",
    required: true,
  },
  {
    key: "description",
    type: "description",
    label: "Help Text",
    required: false,
  },
  {
    key: "isEdit",
    type: "isEdit",
    label: "",
    required: false,
  },
];

@Component({
    selector: "app-add-widget",
    templateUrl: "./widget.component.html",
    styleUrls: ["./widget.component.scss"],
    standalone: false
})
export class WidgetDialogComponent implements OnInit {
  public categories: any;
  public addWidgetForm!: UntypedFormGroup;
  public canvasType: any;
  public action = "ADD";
  dragDisabled = true;
  faGripDotsVertical = faGripDotsVertical;
  displayedColumns: string[] = COLUMNS_SCHEMA.map((col) => col.key);
  dataSource = USER_DATA;
  columnsSchema: any = COLUMNS_SCHEMA;
  @ViewChild("target") private myScrollContainer!: ElementRef;

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<WidgetDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      if (data.itemArray) {
        this.buttonTitle = data.buttonTitle;
        this.workflowId = data.workflowId;
        this.internalId = data.internalId;
        this.recordId = data.recordId;
        this.action = "update";

        data.itemArray.forEach((fields: any) => {
          const populatedRow = {
            id: Math.floor(
              Math.random() * Math.floor(Math.random() * Date.now())
            ),
            title: fields.title,
            linkType: fields.linkType,
            link: fields.link,
            workflowId: fields.workflowId,
            internalId: fields.internalId,
            recordId: fields.recordId,
            description: fields.description,
            isEdit: true,
            type: fields.type,
          };
          this.dataSource = [populatedRow, ...this.dataSource];
        });
      }
      this.workflows = data.workflows;
      this.records = data.records;
      this.internals = data.internals;
    }
  }

  workflowId!: number;
  recordId!: number;
  internalId!: number;

  workflows!: any;
  records!: any;
  internals!: any;
  buttonTitle: string = "";
  description!: string;
  faTrash = faTrash;
  emptyVal: any;
  titleLength = 30;

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop =
        this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {}
  }
  addRow() {
    const newRow = {
      id: Math.floor(Math.random() * Math.floor(Math.random() * Date.now())),
      title: "",
      linkType: "Direct",
      link: "",
      workflowId: this.emptyVal,
      recordId: this.emptyVal,
      internalId: this.emptyVal,
      description: "",
      isEdit: true,
      type: "row",
    };
    // this.dataSource = [newRow, ...this.dataSource];
    this.dataSource = [...this.dataSource, newRow];
    // this.dataSource.push(newRow);
    this.getTitleLength();

    setTimeout(() => {
      this.scrollToBottom();
      // this.validateForm();
    }, 100);
  }
  addSection() {
    const newRow = {
      id: Math.floor(Math.random() * Math.floor(Math.random() * Date.now())),
      title: "",
      linkType: "Direct",
      link: "",
      workflowId: this.emptyVal,
      recordId: this.emptyVal,
      internalId: this.emptyVal,
      description: "",
      isEdit: true,
      type: "section",
    };
    // this.dataSource = [newRow, ...this.dataSource];
    this.dataSource = [...this.dataSource, newRow];
    // this.dataSource.push(newRow);
    this.getTitleLength();
    setTimeout(() => {
      this.validateForm();
      this.scrollToBottom();
    }, 100);
  }

  removeRow(id: any) {
    this.dataSource = this.dataSource.filter((u) => u.id !== id);
    this.getTitleLength();
  }
  getWorkflowName(id: any) {
    const selected = this.workflows.filter((u: any) => u.value == id);
    return selected[0].text;
  }
  getRecordName(id: any) {
    const selected = this.records.filter((u: any) => u.id == id);
    return selected[0].name;
  }

  onChange(event: any, element: any) {
    element.workflowId = this.emptyVal;
    element.recordId = this.emptyVal;
    element.internalId = this.emptyVal;
    element.link = this.emptyVal;
  }

  drop(event: CdkDragDrop<string[]>) {
    const prevIndex = this.dataSource.findIndex((d) => d === event.item.data);
    moveItemInArray(this.dataSource, prevIndex, event.currentIndex);
    const deepClone = JSON.parse(JSON.stringify(this.dataSource));
    this.dataSource = deepClone;
    this.dragDisabled = true;
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  addWidget() {
    const widget = { items: this.dataSource, form: this.addWidgetForm };
    this.dialogRef.close(widget);
  }
  getTitleLength() {
    if (this.dataSource.length > 1) {
      this.titleLength = 128;
    } else {
      this.titleLength = 30;
    }
  }
  generateLink(obj: any, element: any, i: any) {
    element.recordId = this.emptyVal;
    element.workflowId = this.emptyVal;
    element.internalId = this.emptyVal;
    const linkType = element.linkType;

    switch (linkType) {
      case "Direct":
        break;
      case "Platform":
        break;
      case "Workflow":
        if (!obj.value) {
          return false;
        } else {
          element.link = obj.value;
          element.workflowId = obj.value;
          this.dataSource[i] = element;
          return true;
        }
        break;
      case "Internal":
        if (!obj.url) {
          return false;
        } else {
          element.link = obj.url;
          element.internalId = obj.url;
          this.dataSource[i] = element;
          return true;
        }

        break;
      case "Report":
        if (!obj.id) {
          return false;
        } else {
          const full = location.protocol + "//" + location.host;
          element.link = full + "/reports/view/" + obj.id;
          element.recordId = obj.id;
          this.dataSource[i] = element;
          return true;
        }
        break;
    }
    return false;
  }
  validateForm() {
    let disabled = true;
    let validRow = true;
    if (
      this.dataSource.length > 1 &&
      (this.addWidgetForm.get("buttonTitle")!.value == "" ||
        this.addWidgetForm.get("buttonTitle")!.value == null)
    ) {
      this.addWidgetForm.get("buttonTitle")?.setErrors;
      disabled = true;
    } else {
      this.dataSource.forEach((row: any) => {
        if (row.type == "row") {
          validRow = validRow && this.validateRow(row);
        } else {
          validRow = validRow && this.validateSection(row);
        }
      });
      disabled = disabled && !validRow;
    }
    this.addWidgetForm.controls["buttonTitle"].markAsTouched();

    return disabled;
  }

  validateRow(row: any) {
    let validRow = true;
    if (row.title == "") {
      validRow = false;
    } else {
      if (!row.link || row.link == "") {
        validRow = false;
      } else {
        if (row.linkType == "Direct") {
          let result = row.link.substring(0, 6);

          if (result == "mailto") {
            validRow = true;
          } else {
            const urlRegex =
              /^(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/;
            var regex = new RegExp(urlRegex);

            let linkURL = row.link.split("?");
            if (!regex.test(linkURL[0])) {
              validRow = false;
            } else {
              validRow = true;
            }
          }
        }
      }
    }
    return validRow;
  }

  validateSection(row: any) {
    let validRow = true;
    if (row.title == "") {
      validRow = false;
    }
    return validRow;
  }
  ngOnInit(): void {
    this.addWidgetForm = this.fb.group({
      buttonTitle: new UntypedFormControl(this.buttonTitle, [
        Validators.required,
      ]),
      description: new UntypedFormControl(this.description),
    });

    if (this.dataSource.length <= 0) {
      this.addRow();
    }
    this.getTitleLength();
  }
}
